import {BaseApi} from "@/core/api/base.api"
import {AuthService} from "@/core/service/auth.service"

class AuthApi extends BaseApi {
    async makeLogin({email, password}) {
        return await AuthService.makeLogin({email, password})
    }

    async guestLogin(nickname) {
        return await AuthService.guestLogin(nickname)
    }

    async mobileTokenLogin(token) {
        return await AuthService.mobileTokenLogin(token)
    }

    async currentUser() {
        return await AuthService.currentUser()
    }

    async logout() {
        return await AuthService.deleteToken();
    }
}

export const Auth = new AuthApi()